export enum EHttpStatusCodes {
	HTTP_STATUS_OK = 200,
	HTTP_STATUS_NO_CONTENT = 204,
	HTTP_STATUS_UNAUTHORIZED = 401,
	HTTP_STATUS_FORBIDDEN = 403,
	HTTP_STATUS_BAD_REQUEST = 400,
	HTTP_STATUS_NOT_FOUND = 404,
	HTTP_STATUS_CONFLICT = 409,
	HTTP_STATUS_CSRF_TOKEN_MISMATCH = 419,
	HTTP_STATUS_UNPROCESSABLE_ENTITY = 422,
}
